
/*
 * Reducer
 *
 * @param [object] action
 *
 * @return [object] new state
 */
export default function reducer(state, action) {
  let newState = _.merge({}, state);

  switch (action.type) {

    case 'TERM::CHANGE':
      newState.term = action.value;
      break;

    case 'DISC::ADD':
      if (newState.currDisciplines.indexOf(action.value) < 0) {
        newState.currDisciplines.push(action.value);
      }
      break;

    case 'DISC::REMOVE':
      let index = newState.currDisciplines.indexOf(action.value);

      if (index > -1) {
        newState.currDisciplines.splice(index, 1);
      }
      break;

    case 'ALL::RESET':
      newState.currDisciplines = [];
      newState.term = '';
      break;

    case 'ALL_UNITS::RESET':
      newState.currDisciplines = [];
      newState.currDegrees = [];
      newState.currClassification = '';
      newState.currOffering = newState.offerings.map(function(item) {
        return item.trimester;
      });
      newState.avaiDegrees = newState.degrees;
      newState.isDegreeDisabled = true;
      break;

    case 'INIT::REMOVE':
      if (state.initLoad) {
        newState.initLoad = false;
      }
      break;

    case 'RESULT::UPDATE':
      newState.result = this._filter(action.value).concat();
      break;

    case 'RESULT_DISC::UPDATE':
      newState.result = this._filterDisciplines(action.value).concat();
      break;

    case 'RESULT_ALL_UNITS::UPDATE':
      newState.result = this._filterAllUnits(action.value).concat();
      break;

    case 'RESULT::CAT':
      newState.result = _.merge({}, this._catDegrees(newState.result));
      break;

    case 'RESULT_DISC::DIV':
      newState.result = _.merge({}, this._divDisciplines(newState.result));
      break;

    case 'COUNT::UPDATE':
      let postgraduateCount = state.result.hasOwnProperty('postgraduate') ?
          state.result.postgraduate.length : 0,
        undergraduateCount = state.result.hasOwnProperty('undergraduate') ?
          state.result.undergraduate.length : 0;

      newState.count = postgraduateCount + undergraduateCount;
      break;

    case 'ALL_UNITS_COUNT::UPDATE':
      newState.count = newState.result.length;
      break;

    case 'COUNT_DISC::UPDATE':
      let firstColumnCount = state.result.hasOwnProperty('firstColumn') ?
          state.result.firstColumn.length : 0,
        secondColumnCount = state.result.hasOwnProperty('secondColumn') ?
          state.result.secondColumn.length : 0;

      newState.count = firstColumnCount + secondColumnCount;
      break;

    case 'LBOX::OPEN':
      newState.showLightbox = true;
      break;

    case 'LBOX::TOGGLE':
      newState.showLightbox = !state.showLightbox;
      break;

    case 'LBOX::CLOSE':
      newState.showLightbox = false;
      break;

    case 'ABOX::OPEN':
      newState.showAlertbox = true;
      break;

    case 'ABOX::TOGGLE':
      newState.showAlertbox = !state.showAlertbox;
      break;

    case 'ABOX::CLOSE':
      newState.showAlertbox = false;
      break;

    case 'CURR_DEGREE::UPDATE':
      let currDegree = _.find(state.degrees, { assetid: action.value });
      newState.currDegree = currDegree;

      // add current degree object to browser local storage
      if (localStorage) {
        localStorage.setItem('last_visited_course', JSON.stringify(currDegree));
      }
      break;

    case 'CURR_DISC::UPDATE':
      let currDisc = _.find(state.disciplines, { label: action.value });
      newState.currDiscipline = currDisc;

      // add current degree object to browser local storage
      if (localStorage) {
        localStorage.removeItem('last_visited_course');
      }
      break;

    case 'UNITS::UPDATE':
      newState.currUnits = action.value;
      break;

    case 'UNITS::REMOVE':
      newState.currUnits = {};
      break;

    case 'UNITS::FETCH':
      newState.showLightbox = true;
      newState.currDegree = _.find(state.degrees, { assetid: action.value });

      // fire ajax
      this._$fetchData(state.options.url_fetch_units, { degree_id: action.value }, (result) => {

        this.dispatchReducer({
        type: 'UNITS::UPDATE',
        value: result
      });
  });
  break;

case 'UNITS_BY_DISC::FETCH':
  newState.showLightbox = true;
  newState.currDiscipline = _.find(state.disciplines, { label: action.value });

  // fire ajax
  this._$fetchData(state.options.url_fetch_units, { name: action.value }, (result) => {

    this.dispatchReducer({
    type: 'UNITS::UPDATE',
    value: result
  });
});
  break;

case 'TEMP_CLASS::UPDATE':
  newState.tempClassification = action.value;
  break;

case 'UNIT_COMPARE::INIT':
  if (localStorage) {
    newState.comparedUnits = localStorage.getItem('comparison_cart') === undefined ||
    localStorage.getItem('comparison_cart') === null ? [] : JSON.parse(localStorage.getItem('comparison_cart'));
  }
  break;

case 'UNIT_COMPARE::ADD':
  newState.comparedUnits.push(action.value);
  if (localStorage) {
    localStorage.setItem('comparison_cart', JSON.stringify(newState.comparedUnits));
  }
  break;

case 'UNIT_COMPARE::REMOVE':
  let _index = _.findIndex(newState.comparedUnits, action.value);
  newState.comparedUnits.splice(_index, 1);
  if (localStorage) {
    localStorage.setItem('comparison_cart', JSON.stringify(newState.comparedUnits));
  }
  break;

case 'UNIT_COMPARE::CLEAR':
  newState.comparedUnits.length = 0;
  if (localStorage) {
    localStorage.setItem('comparison_cart', JSON.stringify(newState.comparedUnits));
  }
  break;

case 'ALL_UNITS_DISC::UPDATE':
  newState.currDisciplines = action.value;

  break;

case 'ALL_UNITS_DEGREES::UPDATE':
  newState.currDegrees = action.value;
  break;

case 'ALL_UNITS_CLASS::UPDATE':
  newState.currClassification = action.value;
  break;

case 'ALL_UNITS_AVAI_DEGREES::UPDATE':
  let newAvaiDegrees = newState.degrees.filter(function(item) {

    return this._hasDisciplinesPlus(item.discipline_values, action.value);
  }, this);

  newState.avaiDegrees = newAvaiDegrees;
  break;

case 'ALL_UNITS_DEGREES::DISABLE':
  newState.isDegreeDisabled = action.value;
  break;

case 'ALL_UNITS_OFFERING::UPDATE':
  if (_.indexOf(newState.currOffering, action.value) === -1) {
    newState.currOffering.push(action.value);

  } else {
    _.remove(newState.currOffering, function(n) {
      return n === action.value;
    });
  }
  break;
}

  return newState;
}